export function Badge({v}) {
  if (!v) return null;
  return <span className={`badge ${v}`}>{v}</span>;
}

export function Stage({s}) {
  const labels = {
    S1_symmetry: 'S1 symmetry', S2_alignn_gap: 'S2 ALIGNN',
    S3_vasp_relax: 'S3 VASP relax', S4_vasp_magnetic: 'S4 magnetic',
    S5_mp_hull: 'S5 hull', S6_prophet_phonons: 'S6 Prophet',
    S7_qe_relax_pm: 'S7 QE P/M', S8_qe_phonons: 'S8 phonons',
    S9_epw_tc: 'S9 EPW Tc',
  };
  return <>{labels[s] || s}</>;
}

export function fmtTime(t) {
  if (!t) return '—';
  return t.replace('T', ' ').slice(0, 19);
}

export function jsonShort(v, max = 120) {
  if (v == null) return '—';
  const s = JSON.stringify(v);
  return s.length > max ? s.slice(0, max) + '…' : s;
}
